module.exports = __webpack_public_path__ + "img/step2_text.083e6f66.png";